export default __webpack_public_path__ + "static/media/03.ff2c1a2d.png";